import { render, staticRenderFns } from "./DesignatedUserTermsOfUser.vue?vue&type=template&id=22a7d7f3&scoped=true"
var script = {}
import style0 from "./DesignatedUserTermsOfUser.vue?vue&type=style&index=0&id=22a7d7f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7d7f3",
  null
  
)

export default component.exports